import { formatRelativeTime } from "../lib/formatRelativeTime";
import { useNow } from "./useNow";

// Reactive counterpart to the pure formatter: call once at the top of a
// component, use the returned function anywhere in the render (row loops and
// helpers included). The minute tick keeps the strings fresh inside compiled
// components, whose renders are cached and would otherwise freeze a
// Date.now()-derived value at its first computation.
export function useFormatRelativeTime(): (timestamp: number) => string {
  const now = useNow(60_000);
  return (timestamp) => formatRelativeTime(timestamp, now);
}
